import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowLeft, FiZap, FiShield, FiUsers, FiMapPin, FiHeart, FiTruck } from 'react-icons/fi';

const SobreNos = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-gradient-to-r from-[#1A1A1A] to-[#DC143C] text-white">
        <div className="max-w-4xl mx-auto px-4 py-8">
          <Link to="/" className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-4">
            <FiArrowLeft /> Voltar
          </Link>
          <div className="flex items-center gap-3 mb-4">
            <svg width="48" height="60" viewBox="0 0 80 100">
              <defs>
                <linearGradient id="boltGradAbout" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#FFED4A" />
                  <stop offset="50%" stopColor="#FFD700" />
                  <stop offset="100%" stopColor="#FFA500" />
                </linearGradient>
              </defs>
              <path d="M45 0 L25 40 L40 40 L20 70 L35 70 L10 100 L50 60 L35 60 L55 30 L40 30 L60 0 Z" fill="url(#boltGradAbout)"/>
            </svg>
            <div>
              <h1 className="text-3xl font-bold">
                <span className="text-white">BARUERI</span>
                <span className="text-[#FFD700]">FLASH</span>
              </h1>
              <p className="text-white/70">Entregas rápido como um raio!</p>
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-8">
        {/* Mission */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#1A1A1A] mb-4">Nossa Missão</h2>
          <p className="text-gray-600 leading-relaxed text-lg">
            Nascemos com o objetivo de conectar os moradores de Barueri às melhores lojas de eletrônicos 
            da cidade, oferecendo uma experiência de compra rápida, segura e conveniente. Acreditamos que 
            comprar tecnologia não precisa ser complicado – e a entrega não precisa demorar dias.
          </p>
        </section>

        {/* Values */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#1A1A1A] mb-6">Nossos Valores</h2>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-white rounded-2xl p-6 shadow-sm">
              <div className="w-12 h-12 bg-[#DC143C]/10 rounded-xl flex items-center justify-center mb-4">
                <FiZap className="text-[#DC143C] text-2xl" />
              </div>
              <h3 className="font-bold text-[#1A1A1A] mb-2">Agilidade</h3>
              <p className="text-gray-600 text-sm">
                Entregas rápidas para que você não precise esperar. Nosso compromisso é com a sua comodidade.
              </p>
            </div>
            <div className="bg-white rounded-2xl p-6 shadow-sm">
              <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center mb-4">
                <FiShield className="text-green-600 text-2xl" />
              </div>
              <h3 className="font-bold text-[#1A1A1A] mb-2">Segurança</h3>
              <p className="text-gray-600 text-sm">
                Pagamentos seguros, entregadores verificados e código de confirmação para cada entrega.
              </p>
            </div>
            <div className="bg-white rounded-2xl p-6 shadow-sm">
              <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4">
                <FiHeart className="text-blue-600 text-2xl" />
              </div>
              <h3 className="font-bold text-[#1A1A1A] mb-2">Comunidade</h3>
              <p className="text-gray-600 text-sm">
                Valorizamos o comércio local de Barueri, fortalecendo a economia da nossa cidade.
              </p>
            </div>
          </div>
        </section>

        {/* How it Works */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#1A1A1A] mb-6">Como Funciona</h2>
          <div className="space-y-4">
            <div className="flex gap-4 items-start">
              <div className="w-10 h-10 bg-[#DC143C] text-white rounded-full flex items-center justify-center font-bold flex-shrink-0">1</div>
              <div>
                <h3 className="font-bold text-[#1A1A1A]">Escolha seus produtos</h3>
                <p className="text-gray-600">Navegue pela vitrine e adicione os eletrônicos que deseja ao carrinho.</p>
              </div>
            </div>
            <div className="flex gap-4 items-start">
              <div className="w-10 h-10 bg-[#DC143C] text-white rounded-full flex items-center justify-center font-bold flex-shrink-0">2</div>
              <div>
                <h3 className="font-bold text-[#1A1A1A]">Pague via PIX</h3>
                <p className="text-gray-600">Pagamento instantâneo e seguro direto pelo app do seu banco.</p>
              </div>
            </div>
            <div className="flex gap-4 items-start">
              <div className="w-10 h-10 bg-[#DC143C] text-white rounded-full flex items-center justify-center font-bold flex-shrink-0">3</div>
              <div>
                <h3 className="font-bold text-[#1A1A1A]">Acompanhe em tempo real</h3>
                <p className="text-gray-600">Veja seu entregador no mapa e saiba exatamente quando ele chegará.</p>
              </div>
            </div>
            <div className="flex gap-4 items-start">
              <div className="w-10 h-10 bg-green-500 text-white rounded-full flex items-center justify-center font-bold flex-shrink-0">✓</div>
              <div>
                <h3 className="font-bold text-[#1A1A1A]">Receba em casa</h3>
                <p className="text-gray-600">Confirme a entrega com seu código de segurança e aproveite!</p>
              </div>
            </div>
          </div>
        </section>

        {/* Numbers */}
        <section className="mb-12 bg-gradient-to-r from-[#1A1A1A] to-[#2D2D2D] rounded-2xl p-8 text-white">
          <h2 className="text-2xl font-bold mb-6 text-center">BarueriFlash em Números</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
            <div>
              <FiUsers className="mx-auto text-3xl text-[#FFD700] mb-2" />
              <p className="text-3xl font-bold">500+</p>
              <p className="text-white/60 text-sm">Usuários</p>
            </div>
            <div>
              <FiShoppingBag className="mx-auto text-3xl text-[#FFD700] mb-2" />
              <p className="text-3xl font-bold">50+</p>
              <p className="text-white/60 text-sm">Lojas</p>
            </div>
            <div>
              <FiTruck className="mx-auto text-3xl text-[#FFD700] mb-2" />
              <p className="text-3xl font-bold">1000+</p>
              <p className="text-white/60 text-sm">Entregas</p>
            </div>
            <div>
              <FiMapPin className="mx-auto text-3xl text-[#FFD700] mb-2" />
              <p className="text-3xl font-bold">100%</p>
              <p className="text-white/60 text-sm">Barueri</p>
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#1A1A1A] mb-4">Fale Conosco</h2>
          <div className="bg-white rounded-2xl p-6 shadow-sm space-y-4">
            <div>
              <p className="text-gray-500 text-sm">Email</p>
              <a href="mailto:contato@barueriflash.com.br" className="text-[#DC143C] font-medium hover:underline">
                contato@barueriflash.com.br
              </a>
            </div>
            <div>
              <p className="text-gray-500 text-sm">Suporte</p>
              <a href="mailto:suporte@barueriflash.com.br" className="text-[#DC143C] font-medium hover:underline">
                suporte@barueriflash.com.br
              </a>
            </div>
            <div>
              <p className="text-gray-500 text-sm">Localização</p>
              <p className="text-gray-800">Barueri, São Paulo - Brasil</p>
            </div>
          </div>
        </section>

        {/* Legal Links */}
        <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-500 pt-8 border-t">
          <Link to="/termos" className="hover:text-[#DC143C]">Termos de Uso</Link>
          <span>•</span>
          <Link to="/privacidade" className="hover:text-[#DC143C]">Política de Privacidade</Link>
          <span>•</span>
          <Link to="/faq" className="hover:text-[#DC143C]">FAQ</Link>
        </div>
      </main>
    </div>
  );
};

// Need to import this icon
const FiShoppingBag = ({ className }) => (
  <svg className={className} width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"></path>
    <line x1="3" y1="6" x2="21" y2="6"></line>
    <path d="M16 10a4 4 0 01-8 0"></path>
  </svg>
);

export default SobreNos;
